export default [
  {
    path: 'gestao/terminais/msg-rodape',
    name: 'msg-rodape',
    component: () => import('./index'),
    meta: {
      visible: true,
      title: 'Mensagem de rodapé',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Gestão', link: 'gestao' },
        { name: 'Terminais', link: 'terminais' },
        { name: 'Mensagem de rodapé' }
      ]
    }
  }
]